export class Notifications {
    notifications: any[] = [];

    constructor() { }

    add(e: any) {
        this.notifications.push({
            id: e.timeStamp,
            type: e.detail.type,
            content: e.detail.content,
            action: e.detail.action,
            actionText: e.detail.actionText,
            displayDuration: e.detail.displayDuration,
            secondaryAction: e.detail.secondaryAction,
            secondaryActionText: e.detail.secondaryActionText,
        });
    }

    remove(notification: any) {
        this.notifications = this.notifications.filter(i => i.id !== notification.id);
    }
}
